define(['jquery', 'ajax_helper', 'forms', 'erv_framework','erv_translate'], function ($, AjaxHelper, Forms, Framework, Translate) {
	var PriceCheck = function () {
		var self = this;
		self.$priceCheckBlock = $('#erv-body .pricecheck-block');
		self.ajaxHelper = new AjaxHelper();
		self.forms = new Forms();
		self.framework = new Framework();
		self.translate = new Translate();
		
		self.initEventHandlers = function () {
			self.$priceCheckBlock.on('click', 'button.btn', function(e) {
				e.preventDefault();
				e.stopPropagation();

				var $form = $(this).parents('form');
				
				self.ajaxHelper.submitForm($form, function (data) {
					// if has annual price, set it or clear
					var $annual = self.$priceCheckBlock.find('.annual-price');

					if (data.annualPrice && data.annualPrice != "0") {
						var label = $annual.data('label');
						$annual.text(label && label.length ? label.replace('{0}', data.annualPrice + ' ' + data.currency) : '');
					} else {
						$annual.text('');
					}

					if (data.price) {
						var $price = self.$priceCheckBlock.find('.price');

						$price.text(data.price + ' ' + data.currency);
						self.togglePrice(true);
					}

					self.translate.initNoTranslate();
				}, function (data) {
					if (data.messages) {
						var $errorLabels = self.$priceCheckBlock.find('.errors'),
							messages = data.messages.toString().split(',');

						$errorLabels.empty();

						for (var message of messages) {
							$errorLabels.append($('<span class="error"></span>').text(message));
						}

						self.togglePrice(false);
						$errorLabels.removeClass('hide');
						$form.removeAttr('data-js');
					}
				});
			});

			self.$priceCheckBlock.on('input', '#DurationSlider', function () {
				var $slider = $(this),
					val = $slider.val();

				if (val > 31) {
					val = Number(val) + (7*(val-31));
				}

				if (val > 365) {
					val = 365;
				}

				$slider.parents('.duration-container').find('.duration').val(val);
			});

			self.$priceCheckBlock.on('blur keyup', '.duration', function (e) {
				var $input = $(this),
					duration = $input.val();

				if (duration > 365) {
					duration = 365;
				} else if (duration < 1) {
					duration = 1;
				}

                // allow the user to clear the input
                if ($input.val()) {
                    $input.val(duration);
                }

                // convert back to slider units
                var sliderUnits = duration;
                if (duration > 31) {
                    sliderUnits = 31 + Math.round((duration - 31) / 7);
                }

                $input.parents('.duration-container').find('#DurationSlider').val(sliderUnits);
				self.$priceCheckBlock.trigger('change');
			});

			self.$priceCheckBlock.on('blur keyup', '.age', function (e) {
				var $input = $(this),
					age = $input.val();

				if (age > 99) {
					age = 99;
				} else if (age < 0) {
					age = 0;
				}

				$input.val(age);

				self.$priceCheckBlock.trigger('change');
			});

			self.$priceCheckBlock.on('change', 'select', function (e) {
				var $select = $(this),
					visitorExist = $select.find('option[data-js="visitor"]');

				if (visitorExist.length === 0) {
					return;
				}

				var visitorSelected = $select.find('option[data-js="visitor"]:selected').length,
				$destinationsNis = self.$priceCheckBlock.find('ul.priceregion li[data-js="nis"]'),
				$destinationVisitor = self.$priceCheckBlock.find('ul.priceregion li[data-js="visitor"]');

				//reset
				$destinationVisitor.addClass('hide');
				$destinationsNis.addClass('hide');

				$destinationsNis.each(function () {
					self.forms.disableFormElementsInContainer($(this), visitorSelected);
				});

				self.forms.disableFormElementsInContainer($destinationVisitor, !visitorSelected);

				if (visitorSelected) {
					$destinationVisitor.removeClass('hide');
				} else {
					$destinationsNis.removeClass('hide');
				}
			});

			self.$priceCheckBlock.on('change', function() {
				self.togglePrice(false);
                self.$priceCheckBlock.find('.errors').addClass('hide');
                self.$priceCheckBlock.find('.btn-show-price').prop('disabled', !self.$priceCheckBlock.valid());
			});
		}

		self.togglePrice = function (show) {
			var $price = self.$priceCheckBlock.find('.price'),
				$info = self.$priceCheckBlock.find('.italic'),
				$annual = self.$priceCheckBlock.find('.annual-price');

			if (show) {
				$price.removeClass('hide');
				$info.removeClass('hide');
				if ($annual && $annual.text().length) {
					$annual.removeClass('hide');
				}
				self.$priceCheckBlock.find('.errors').addClass('hide');
			} else {
				$price.addClass('hide');
				$info.addClass('hide');
				$annual.addClass('hide');
			}
		}
	}

	PriceCheck.prototype.init = function () {
		var self = this;
		self.initEventHandlers();
		// trigger change if it is only visitor
		self.$priceCheckBlock.find('select').trigger('change');
	}

	return PriceCheck;
});